import { Box, Button, Card, Grid, Radio, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import BlueMediumButton from "../../../../../../components/customButtons/BlueMediumButton";
import { getAllPaymentModes } from "../../../PurchaseTestApis";
import Loader from "../../../../../../../SAPPages/components/Loader/Loader";

export default function ShowAllPaymentMethods({
  handleClose,
  setselectedPaymentMode,
  setPaymentOptions,
  paymentOptions,
}) {
  const [selected, setSelected] = useState("razorpay");

  const handleContinue = () => {
    setselectedPaymentMode(selected);
    handleClose();
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            textAlign="start"
            color="#000000"
            fontFamily="Inter"
            fontSize="18px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            style={{ fontWeight: 600 }}
          >
            Select Payment Method
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography
            textAlign="start"
            color="#444444"
            fontFamily="Inter"
            fontSize="14px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            style={{ fontWeight: 500 }}
          >
            Preferred Method for Secure Transaction :
          </Typography>
        </Grid>

        {paymentOptions?.map((item) => (
          <Grid item xs={12} key={item.id}>
            <Card
              onClick={() => setSelected(item)}
              sx={{
                p: 2,
                borderRadius: "12px",
                cursor: "pointer",
                border:
                  selected?.id === item.id
                    ? "2px solid #FFE2FA"
                    : "1px solid #eee",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: "#FFFDFF",
                transition: "0.2s ease-in-out",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {/* <img src={item.icon} alt="" style={{ width: "100px" }} /> */}
                <Typography
                  fontFamily="Inter"
                  fontWeight={600}
                  fontSize="16px"
                  color="#222222"
                >
                  {item.payment_mode}
                </Typography>
              </Box>

              <Radio
                checked={selected?.id === item.id}
                sx={{
                  color: "#9D0385",
                  "&.Mui-checked": { color: "#9D0385" },
                }}
              />
            </Card>
          </Grid>
        ))}

        <Grid item xs={12} container gap={2} justifyContent="center" mt={1}>
          <Button
            size="small"
            onClick={handleClose}
            sx={{
              color: "#555555",
              fontFamily: "Inter",
              fontWeight: 800,
              fontSize: "14px",
              border: "2px solid #EEEEEE",
              minWidth: "35%",
              height: 30,
            }}
          >
            Go Back
          </Button>
          <BlueMediumButton
            buttonTitle="Continue"
            minWidth="35%"
            onClick={handleContinue}
          />
        </Grid>
      </Grid>
    </>
  );
}
